import { Injectable } from '@angular/core';
import { HighchartsColorCodes, WindowWalkService } from '@nrwl/common-lib';
import { round } from 'lodash';

export interface TableData {
  header: string;
  value: string;
  hide?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ReportsTransformationService {
  //eslint-disable-next-line
  truespeedTestConfig: any;
  httpTestConfig: any;
  isAgentToJmep = false;
  constructor(private windowWalkService: WindowWalkService) {}
  //eslint-disable-next-line
  getTrueSpeedTestConfigs(configuration: any, testType: any, testMode: string): Array<TableData> {
    this.isAgentToJmep = testMode === 'ma-to-jmep';
    if (testType === 'thin-engine') {
      this.truespeedTestConfig = [
        {
          header: 'Upstream CIR',
          value: configuration.upstreamCir + ' Mbps'
        },
        {
          header: 'Downstream CIR',
          value: configuration.downstreamCir + ' Mbps'
        },
        {
          header: 'Engine A',
          value: parseInt(configuration?.engineA?.port)
            ? configuration?.engineA?.address + ':' + configuration?.engineA?.port
            : configuration?.engineA?.address,
          hide: !configuration.engineA
        },
        {
          header: 'TCP Port',
          value: configuration.tcpPort
        },
        {
          header: 'Run Dynamic Saturation Test',
          value: configuration.dynamicSaturation
        }
      ];
    } else {
      this.truespeedTestConfig = [
        {
          header: 'Upstream CIR',
          value: configuration.upstreamCir + ' Mbps'
        },
        {
          header: this.isAgentToJmep ? 'CIR' : 'Downstream CIR',
          value: configuration.downstreamCir + ' Mbps'
        },
        {
          header: 'Engine A',
          value: parseInt(configuration?.engineA?.port)
            ? configuration?.engineA?.address + ':' + configuration?.engineA?.port
            : configuration?.engineA?.address,
          hide: !configuration.engineA
        },
        {
          header: 'Engine B',
          value: parseInt(configuration?.engineB?.port)
            ? configuration?.engineB?.address + ':' + configuration?.engineB?.port
            : configuration?.engineB?.address,
          hide: !configuration?.engineB
        },
        {
          header: 'JMEP IP Address',
          value: configuration.jmepIpAddress,
          hide: !this.isAgentToJmep
        },
        {
          header: 'Threshold',
          value: configuration.thresholdUnitMbps
            ? configuration.threshold + ' Mbps'
            : configuration.threshold + ' %'
        },
        {
          header: 'TCP Port',
          value: configuration.tcpPort
        },
        {
          header: 'Number of Window Walks',
          value: configuration.numWindow
        },
        {
          header: 'Window Walk Duration',
          value: configuration.windowDuration + 's'
        },
        {
          header: 'Connection Count',
          value: configuration.connections !== 0 ? configuration.connections : 'AUTO'
        },
        {
          header: 'Starting Percent of CIR',
          value: configuration?.percentStartWindowWalk + '%',
          hide: !configuration.percentStartWindowWalk
        },
        {
          header: 'Class of Service Type',
          value: configuration.serviceType.type.toUpperCase()
        },
        {
          header: 'Class of Service Byte',
          value:
            configuration.serviceType.type === 'dscp'
              ? configuration.serviceType.dscp
              : configuration.serviceType.showTos
        },
        {
          header: 'Run Saturation Test',
          value: configuration.runSaturationWindow
        },
        {
          header: 'Run Dynamic Saturation Test',
          value: configuration.dynamicSaturation,
          hide: testMode === 'ma-to-ma'
        },
        {
          header: 'Boost Window',
          value: configuration?.percentOverSaturateWindow + ' %',
          hide:
            configuration.runSaturationWindow !== 'true' ||
            configuration.dynamicSaturation === 'true'
        },
        {
          header: 'Boost Connection',
          value: configuration?.percentOverSaturateConnections + ' %',
          hide:
            configuration.runSaturationWindow !== 'true' ||
            configuration.dynamicSaturation === 'true'
        }
      ];
      if (this.isAgentToJmep) {
        this.truespeedTestConfig = this.truespeedTestConfig.filter(
          item => item.header !== 'Upstream CIR'
        );
      }
    }
    return this.truespeedTestConfig;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  getHTTPTestConfigs(configuration: any, testType: any): Array<TableData> {
    {
      this.httpTestConfig = [
        ...(configuration.engineAtoBThreshold
          ? [
              {
                header: 'Upload Throughput',
                value: configuration.engineAtoBThreshold + 'Mbps'
              }
            ]
          : []),
        ...(configuration.engineBtoAThreshold
          ? [
              {
                header: 'Download Throughput',
                value: configuration.engineBtoAThreshold + 'Mbps'
              }
            ]
          : []),
        ...(configuration.engineAtoBUrl
          ? [
              {
                header: 'Engine A to B URL',
                value: configuration.engineAtoBUrl
              }
            ]
          : []),
        ...(configuration.engineBtoAUrl
          ? [
              {
                header: 'Engine B to A URL',
                value: configuration.engineBtoAUrl
              }
            ]
          : []),
        {
          header: 'Engine A',
          value: parseInt(configuration?.engineA?.port)
            ? configuration?.engineA?.address + ':' + configuration?.engineA?.port
            : configuration?.engineA?.address,
          hide: !configuration.engineA
        },
        {
          header: 'Engine B',
          value: parseInt(configuration?.engineB?.port)
            ? configuration?.engineB?.address + ':' + configuration?.engineB?.port
            : configuration?.engineB?.address,
          hide: !configuration?.engineB
        },
        {
          header: 'JMEP IP Address',
          value: configuration.jmepIpAddress,
          hide: !this.isAgentToJmep
        },
        {
          header: 'TCP Port',
          value: configuration.tcpPort
        },
        {
          header: ' Maximum Duration',
          value: configuration.maxTestDuration + 's'
        },
        {
          header: ' Type',
          value: configuration.type.toUpperCase()
        }
      ];
    }
    return this.httpTestConfig;
  }
  //eslint-disable-next-line
  getClientConfiguration(clientInfo: any, testType: any): Array<TableData> {
    let configuration = [];
    if (testType !== 'thin-engine') {
      configuration = [
        {
          header: 'Client Public IP',
          value: clientInfo.systemInfo.engBPublicIPAddr,
          hide: clientInfo.systemInfo.engBPublicIPAddr == ''
        },
        {
          header: 'Client Private IP',
          value: clientInfo.systemInfo.engBPrivateIPAddr,
          hide: clientInfo.systemInfo.engBPrivateIPAddr == ''
        },
        {
          header: 'CPU Vendor',
          value: clientInfo.systemInfo.cpuVendor
        },
        {
          header: 'CPU Model',
          value: clientInfo.systemInfo.cpuModel
        },
        {
          header: 'CPU Number',
          value: clientInfo.systemInfo.cpuNumber
        },
        {
          header: 'Memory',
          value: clientInfo.systemInfo.memory + ' MB'
        },
        {
          header: 'OS Version',
          value: clientInfo.systemInfo.osVersion
        },
        {
          header: 'Max CPU Utilization',
          value: clientInfo.systemInfo.maxCpuUsage + ' %'
        }
      ];
      clientInfo.interfaces.forEach(item => {
        if (item.transmitBuffer === null && item.receiveBuffer === null) {
          configuration.push({
            header: 'Interface &lt;IP Address&gt;',
            value: `${item.name} <${item.ip}>`
          });
        }
        if (item.transmitBuffer && item.receiveBuffer) {
          configuration.push({
            header: 'Interface &ltIP Address&gt,&ltTransmit Buffers, Receive Buffers&gt',
            value: `${item.name}<${item.ip}>, <${item.transmitBuffer}, ${item.receiveBuffer}>`
          });
        }
      });
    } else {
      if (clientInfo.systemInfo.engBPublicIPAddr) {
        configuration.push({
          header: 'Client Public IP',
          value: clientInfo.systemInfo.engBPublicIPAddr
        });
      }
      if (clientInfo.systemInfo.engBPrivateIPAddr) {
        configuration.push({
          header: 'Client Private IP',
          value: clientInfo.systemInfo.engBPrivateIPAddr
        });
      }
      configuration.push(
        {
          header: 'Device Type',
          value: clientInfo.systemInfo.deviceType
        },
        {
          header: 'OS Version',
          value: clientInfo.systemInfo.deviceOS
        },
        {
          header: 'Browser',
          value: clientInfo.systemInfo.browserVersion
        },
        {
          header: 'Latitude',
          value: clientInfo.systemInfo.latitude
        },
        {
          header: 'Longitude',
          value: clientInfo.systemInfo.longitude
        }
      );
    }
    return configuration;
  }
  //eslint-disable-next-line
  createMemoryUsageChart(data: any, type: string): any {
    const placeHolder = type + 'Memory';

    const option = {
      chart: {
        renderTo: placeHolder,
        type: 'line',
        height: 335, //IE-firefox max
        width: 870
      },
      plotOptions: {
        line: {
          marker: {
            radius: 3
          }
        }
      },
      credits: { enabled: false },
      title: {
        text: null
      },
      subtitle: {
        text: null
      },
      xAxis: {
        title: {
          text: 'Time (s)'
        },
        labels: {
          style: {
            font: '12px Helvetica'
          }
        },
        tickWidth: 0,
        lineWidth: 0,
        min: 1,
        max: data.length
      },
      yAxis: [
        {
          title: {
            text: 'Memory Usage (%)'
          }
        }
      ],

      series: [
        {
          data: data,
          showInLegend: false,
          color: '#3371b2'
        }
      ]
    };

    return option;
  }
  //eslint-disable-next-line
  createCpuChart(data: any, type: string): any {
    const placeHolder = type + 'Cpu';

    const option = {
      chart: {
        renderTo: placeHolder,
        type: 'line',
        height: 335, //IE-firefox max
        width: 870
      },
      plotOptions: {
        line: {
          marker: {
            radius: 3
          }
        }
      },
      credits: { enabled: false },
      title: {
        text: null
      },
      subtitle: {
        text: null
      },
      xAxis: {
        title: {
          text: 'Time (s)'
        },
        labels: {
          style: {
            font: '12px Helvetica'
          }
        },
        tickWidth: 0,
        lineWidth: 0,
        min: 1,
        max: data.length
      },
      yAxis: [
        {
          title: {
            text: 'CPU Usage (%)'
          }
        }
      ],

      series: [
        {
          data: data,
          showInLegend: false,
          color: '#3371b2'
        }
      ]
    };

    return option;
  }
  //eslint-disable-next-line
  createTrendingChart(isThinClientTest, configuration: any, windowResult: any, type: string): any {
    let secondaryTitle;
    let secondarySeries;
    let secondaryColor;

    if (type === 'retrans_frame') {
      secondaryTitle = 'TCP Retransmitted Frames';
      secondarySeries = windowResult ? windowResult.retransmitted : null;
      secondaryColor = HighchartsColorCodes.OCEAN_BLUE;
    } else if (type === 'retrans_ratio') {
      secondaryTitle = 'TCP Retransmitted Ratio (%)';
      secondarySeries = windowResult ? windowResult.retransRatio : null;
      secondaryColor = HighchartsColorCodes.VIOLET;
    } else if (type === 'rtt') {
      secondaryTitle = 'RTT (ms)';
      secondarySeries = windowResult ? windowResult.rtt : null;
      secondaryColor = HighchartsColorCodes.CEREISE;
    }

    const option = {
      chart: {
        type: 'line',
        height: 335, //IE-firefox max
        width: 870
      },
      credits: { enabled: false },
      title: {
        text: null
      },
      subtitle: {
        text: null
      },
      lang: {
        noData: 'Chart data no longer available'
      },
      xAxis: {
        title: {
          text: 'Time (s)'
        },
        labels: {
          style: {
            font: '12px Helvetica'
          }
        },
        tickWidth: 0,
        lineWidth: 0,
        min: 1,
        max: configuration['windowDuration']
      },
      yAxis: [
        {
          // Primary yAxis
          title: {
            text: 'TCP Throughput (Mbps)'
          }
        },
        {
          // Secondary yAxis
          title: {
            text: secondaryTitle
          },
          opposite: true
        }
      ],
      plotOptions: {
        line: {
          marker: {
            radius: 3
          }
        }
      },

      series: [
        {
          data: windowResult ? windowResult.thruput : null,
          showInLegend: false,
          color: HighchartsColorCodes.DODGER_BLUE
        },
        {
          data: secondarySeries,
          showInLegend: false,
          color: secondaryColor,
          yAxis: 1
        }
      ]
    };
    if (isThinClientTest) {
      option.series.pop();
      option.yAxis[0].title.text = 'Actual TCP Throughput (Mbps)';
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return option;
  }

  createTrendingColumnAndLineChart(
    isThinClientTest: boolean,
    configuration: any, //eslint-disable-line
    windowResult: any, //eslint-disable-line
    type: string,
    direction?: string
    //eslint-disable-next-line
  ): any {
    let secondaryTitle;
    let secondarySeries;
    let secondaryColor;
    let title;
    if (this.isAgentToJmep) {
      title = direction + ' vs';
    } else {
      title = direction + ' TCP Throughput vs';
    }
    let unit = 'ms';

    if (type === 'retrans_frame') {
      secondaryTitle = 'TCP Retransmitted Frames';
      secondarySeries = windowResult ? windowResult.retransmitted : null;
      secondaryColor = HighchartsColorCodes.EARLY_GREEN;
      title += ' TCP Retransmitted Frames';
    } else if (type === 'retrans_ratio') {
      secondaryTitle = 'TCP Retransmitted Ratio (%)';
      secondarySeries = windowResult ? windowResult.retransRatio : null;
      secondaryColor = HighchartsColorCodes.ELECTRIC_VIOLET;
      title += ' TCP Retransmitted Ratio';
      unit = '%';
    } else if (type === 'rtt') {
      secondaryTitle = 'RTT (ms)';
      secondarySeries = windowResult ? windowResult.rtt : null;
      secondaryColor = HighchartsColorCodes.CEREISE;
      title += ' RTT Avg';
    }
    const option = {
      chart: {
        type: 'area',
        height: 335, //IE-firefox max
        width: 870
      },
      credits: { enabled: false },
      title: {
        text: title,
        align: 'left',
        style: {
          fontSize: '14px',
          fontWeight: 700
        }
      },
      subtitle: {
        text: null
      },
      lang: {
        noData: 'Chart data no longer available'
      },
      xAxis: {
        title: {
          text: 'Time (s)',
          style: {
            fontWeight: 700
          }
        },
        labels: {
          style: {
            font: '12px Helvetica'
          }
        },
        tickWidth: 0,
        lineWidth: 0,
        min: 1,
        max: configuration['windowDuration']
      },

      yAxis: [
        {
          // Primary yAxis
          title: {
            text: 'TCP Throughput (Mbps)',
            style: {
              fontWeight: 700
            }
          }
        },
        {
          // Secondary yAxis
          title: {
            text: secondaryTitle,
            style: {
              fontWeight: 700
            }
          },
          opposite: true
        }
      ],
      plotOptions: {
        line: {
          marker: {
            radius: 3
          }
        }
      },

      series: [
        {
          marker: {
            enabled: false
          },
          type: 'column',
          data: windowResult ? windowResult.thruput : null,
          color:
            direction === 'Downstream' || direction === 'Download'
              ? HighchartsColorCodes.OCEAN_BLUE
              : HighchartsColorCodes.DODGER_BLUE,
          name:
            direction === 'Upstream'
              ? 'Upstream TCP Throughput'
              : direction === 'Upload'
              ? 'Upload Throughput'
              : direction === 'Download'
              ? 'Download Throughput'
              : this.isAgentToJmep
              ? 'TCP Throughput'
              : 'Downstream TCP Throughput'
        },
        {
          marker: {
            enabled: true
          },
          type: 'line',
          data: secondarySeries,
          color: secondaryColor,
          yAxis: 1,
          name: secondaryTitle
        }
      ],
      legend: {
        symbolHeight: 7,
        symbolWidth: 7,
        verticalAlign: 'bottom',
        align: 'center',
        enabled: true,
        useHTML: true,
        symbolRadius: 0,
        itemStyle: {
          fontWeight: 'normal',
          fontSize: '8pt'
        }
      }
    };
    if (isThinClientTest) {
      option.series.pop();
      option.yAxis.pop();
      option.yAxis[0].title.text = 'Actual TCP Throughput (Mbps)';
      option.title.text = direction + ' TCP Throughput';
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return option;
  }

  //eslint-disable-next-line
  createBarChart(isThinClientTest, direction, configuration, window, target, actual): any {
    if (document.getElementById(direction + 'BarChart')) {
      const option = this.windowWalkService.getBarChartOption(direction, window.length, false);
      option.xAxis['categories'] = window;
      if (isThinClientTest) {
        option.xAxis.labels.enabled = false;
      }
      //Capping
      for (let i = 0; i < actual.length; i++) {
        const rateUnderTest = target[i];
        if (direction === 'upstream' && actual[i] > rateUnderTest) {
          actual[i] = rateUnderTest;
        }
        if (direction === 'downstream' && actual[i] < rateUnderTest) {
          actual[i] = rateUnderTest;
        }
      }

      option.series[0]['data'] = target;
      option.series[1]['data'] = actual;

      if (direction === 'upstream') {
        option.yAxis['max'] = configuration.upstreamCir * 1.1;
      } else {
        option.yAxis['min'] = configuration.downstreamCir * -1.1;
      }
      return option;
    }
  }

  CreateBulletChart(
    window: any, // eslint-disable-line
    upstreamTarget: Array<number>,
    downstreamTarget: Array<string>,
    upstreamActual: Array<number>,
    downstreamActual: Array<string>,
    runSaturation: boolean,
    dynamicSaturation: boolean,
    testType: string,
    direction?: string
    // eslint-disable-next-line
  ): any {
    const newDownstreamActual = [];
    const newDownstreamTarget = [];
    if (downstreamActual) {
      downstreamActual.forEach(item => {
        if (item || item != '-0') {
          newDownstreamActual.push(item);
        }
      });
    }
    if (downstreamTarget) {
      downstreamTarget.forEach(item => {
        if (item || item != '-0') {
          newDownstreamTarget.push(item);
        }
      });
    }
    const newWindow = [];

    for (let i = 0; i < window.length; i++) {
      let walkName = `Walk ${i + 1}`;
      let additionalString = '';
      if (window.length - 1 === i && runSaturation && testType !== 'thin-engine') {
        walkName = dynamicSaturation ? 'Dynamic Saturation Walk' : 'Saturation Walk';
      }
      if (window[i]?.includes('<br/>')) {
        additionalString = window[i].split('<br/>');
        additionalString = additionalString[additionalString.length - 1];
      }
      newWindow.push(`${walkName}  <br/> ${additionalString}`);
    }
    const options = {
      series: [
        {
          targetOptions: {
            width: '200%',
            color: HighchartsColorCodes.ATLANTIS,
            height: 5,
            borderColor: HighchartsColorCodes.DARKER_GRAY,
            borderRadius: 4,
            borderWidth: 1
          },
          name: direction === 'bidirsequential' || direction === 'Upload' ? 'Upload' : 'Upstream',
          showInLegend: false,
          color: HighchartsColorCodes.DODGER_BLUE,
          data: this.bulletChartSeriesData(
            direction === 'bidirsequential' || direction === 'Upload' ? 'Upload' : 'upstream',
            upstreamActual,
            upstreamTarget,
            HighchartsColorCodes.DODGER_BLUE
          )
        },
        {
          pointWidth: 20,
          pointPadding: 1.25,
          borderWidth: 0,
          targetOptions: {
            width: '200%',
            color: HighchartsColorCodes.ATLANTIS,
            height: 5,
            borderColor: HighchartsColorCodes.DARKER_GRAY,
            borderRadius: 4,
            borderWidth: 1
          },
          name: this.isAgentToJmep
            ? 'Throughput'
            : direction === 'bidirsequential' || direction === 'Download'
            ? 'Download'
            : 'Downstream',
          showInLegend: false,
          color: HighchartsColorCodes.OCEAN_BLUE,
          data: this.bulletChartSeriesData(
            direction === 'bidirsequential' || direction === 'Download' ? 'Download' : 'downstream',
            newDownstreamActual,
            newDownstreamTarget,
            HighchartsColorCodes.OCEAN_BLUE
          )
        }
      ],
      chart: {
        events: {
          load: function () {
            const categoryHeight = 35;
            this.update({
              chart: {
                height: categoryHeight * this.pointCount + (this.chartHeight - this.plotHeight)
              }
            });
          }
        },
        type: 'bullet',
        marginTop: 30,
        inverted: true,
        marginLeft: 100,
        styledMode: false,
        zoomType: 'x'
      },
      lang: {
        noData: 'No data found'
      },
      legend: {
        enabled: false
      },
      credits: {
        enabled: false
      },
      exporting: {
        enabled: false
      },
      title: {
        text: '',
        style: {
          fontSize: '14px'
        }
      },
      xAxis: {
        categories: newWindow,
        labels: {
          style: {
            fontWeight: 700
          },
          enabled: newWindow?.length > 0
        }
      },
      yAxis: {
        min: 0,
        title: null,
        gridLineWidth: 0
      },
      tooltip: {
        valueSuffix: ' Mbps'
      },
      disableZoom: true
    };
    if (this.isAgentToJmep) {
      options['series'] = options['series'].filter(item => item.name === 'Throughput');
    }
    return options;
  }

  bulletChartSeriesData(
    direction: string,
    actual: Array<number>,
    target: Array<number>,
    color: string
  ): Array<{ y: string; target: string; color: string }> {
    let rateUnderTest;
    for (let i = 0; i < actual.length; i++) {
      if (target) {
        rateUnderTest = target[i];
      }
      if (direction === 'upstream' && actual[i] > rateUnderTest) {
        actual[i] = rateUnderTest;
      }
      if (direction === 'downstream' && actual[i] < rateUnderTest) {
        actual[i] = rateUnderTest;
      }
    }
    const data = [];
    for (let i = 0; i < target?.length; i++) {
      let actualValue = direction === 'downstream' ? actual[i] * -1 : actual[i];
      if (direction === 'Download' || direction === 'Upload') {
        actualValue = actual[i];
      }
      let targetValue = direction === 'downstream' ? target[i] * -1 : target[i];
      if (direction === 'Download' || direction === 'Upload') {
        targetValue = target[i];
      }

      if (direction !== 'Download' && direction !== 'Upload') {
        actualValue = round(parseFloat(actualValue?.toFixed(1)), 1);
        targetValue = round(targetValue?.toString(), 1);
        const passFailValue = this.windowWalkService.getPassFailValue(targetValue.toString());
        data.push({
          y: actualValue,
          target: targetValue,
          color: color
        });
      } else {
        // Ensure values are numbers before applying toFixed
        actualValue = Number(actualValue);
        targetValue = parseFloat(targetValue?.toFixed(1));

        actualValue = !isNaN(actualValue) ? parseFloat(actualValue.toFixed(1)) : 0;
        const passFailValue = this.windowWalkService.getPassFailValue(targetValue?.toString());
        if (!isNaN(actualValue) && actualValue > 0) {
          data.push({
            y: actualValue,
            target: targetValue,
            color: color
          });
        }
      }
    }
    return data;
  }
}
